export const ItemTypes = {
    ANSWER: 'answer',
}
